<template>
	<div class="newRulesDetails">
		<el-form label-width='100px' class="qcFrom editFroms contentBigBox" ref="schemeFrom" :rules="rules" :model="schemeFrom" v-loading="loading">
			<el-row>
				<el-form-item label="状态">
					<div class="exportTab marr20">
						<div class="sliderScreeningR">
							<a href="javascript:;" @click="seachTab(true)" :class="schemeFrom.Enable?'active':''">启用</a>
							<a href="javascript:;" @click="seachTab(false)" :class="!schemeFrom.Enable?'active':''">禁用</a>
						</div>
					</div>
				</el-form-item>
			</el-row>
			<el-row>
				<el-row>
					<el-form-item label="名称" prop="Name">
						<el-input size="small" v-model="schemeFrom.Name" placeholder="请输入名称" style="width: 200px;"></el-input>
					</el-form-item>
				</el-row>
				<el-row>
					<el-form-item label="适用类型" prop="Type">
						<el-select size="small" v-model="schemeFrom.Type" placeholder="请选择适用类型">
							<el-option v-for="item in detailsRulesParameter.types" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
						</el-select>
					</el-form-item>
				</el-row>
				<el-form-item label="设备" prop="ModalityType">
					<el-checkbox-group v-model="schemeFrom.ModalityType">
						<el-checkbox v-for="item in detailsRulesParameter.modalityType" :key="item.text" :label="item.text">{{item.text}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="模式" prop="Mode">
					<el-select size="small" v-model="schemeFrom.Mode" placeholder="请选择模式">
						<el-option v-for="item in detailsRulesParameter.mode" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
					</el-select>
				</el-form-item>
			</el-row>
			<div class="dividingLine"></div>
			<el-row>
				<el-form-item label="严重细则">
					<el-button class="marl18" size="small" type="warning"  @click="look(true)">选择严重细则</el-button>
				</el-form-item>
			</el-row>
		 	<el-row class="table" style="margin:0 0 20px 90px;">
				<el-col :span="12">
					<new-scheme-details-table-img-report :list='newSpecialSIList' :title="'严重细则'" />
				</el-col>
			</el-row>
			<el-dialog title="选择添加到方案中的严重细则" :visible.sync="dialogserious" width="80%" center @close='closeElDialog' class="scrollbar exportFrom dialogFrom">
				<el-row class="dialog">
					<el-col :span="24">
						<new-scheme-details-table-serious class="dialogList" v-if="newreportSpecialSIList.length>0" :setList='newreportSpecialSIList' :choiceList="newSpecialSIList"  ref="reportTable" />
					</el-col>
					<div v-if="newreportSpecialSIList.length==0">没有可选数据</div>
				</el-row>
				<span slot="footer" class="dialog-footer">
			        <el-button size="small" class="mart25" type="primary" @click="dialogserious = false">确 定</el-button>
			    </span>
			</el-dialog>
			<div class="dividingLine"></div>
			<el-row>
				<el-form-item label="普通细则">
					<el-select size="small" v-model="schemeFrom.ScoreItemType" placeholder="普通细则">
						<el-option v-for="item in detailsRulesParameter.ScoreItemType" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
					</el-select>
					<el-button class="marl18" size="small" type="warning" @click="look(false)">选择普通细则</el-button>
				</el-form-item>
			</el-row>
			<el-dialog title="选择添加到方案中的普通细则" :visible.sync="setdialogVisible.dialogVisible" width="80%" center @close='closeElDialog' class="scrollbar exportFrom dialogFrom">
				<el-row :gutter="20" class="dialog">
					<el-col :span="getColSpan(schemeFrom.Type, 'img')" v-if="getColSpan(schemeFrom.Type, 'img')">
						<new-scheme-details-table-img
							class="dialogList"
							v-if="newSchemeDetailsImgReport.length>0"
							:setList="newSchemeDetailsImgReport"
							:choiceList="newSchemeImgtList"
							ref="reportTable"
						/>
					</el-col>
					<el-col :span="getColSpan(schemeFrom.Type, 'report')" v-if="getColSpan(schemeFrom.Type, 'report')">
						<new-scheme-details-table-report
							class="dialogList"
							v-if="newSchemeDetailsListReport.length>0"
							:setList="newSchemeDetailsListReport"
							:choiceList="newSchemeReportList"
							ref="reportImgTable"
						/>
					</el-col>
					<el-col :span="getColSpan(schemeFrom.Type, 'history')" v-if="getColSpan(schemeFrom.Type, 'history')">
						<new-scheme-details-table-history
							class="dialogList"
							v-if="newSchemeDetailsHistoryReport.length>0"
							:setList="newSchemeDetailsHistoryReport"
							:choiceList="newSchemeHistoryList"
							ref="reportHistoryTable"
						/>
					</el-col>
					<div v-if="newSchemeDetailsImgReport.length==0 && newSchemeDetailsListReport.length==0 && newSchemeDetailsHistoryReport.length==0">
						没有可选数据
					</div>
				</el-row>
				<span slot="footer" class="dialog-footer">
	                <el-button size="small" class="mart25" type="primary" @click="setdialogVisible.dialogVisible = false">确 定</el-button>
	            </span>
			</el-dialog>

			<el-row class="table" style="margin:0 0 20px 90px;" :gutter="20">
				<el-col :span="colSpan">
					<new-scheme-details-table-img-report :list='newSchemeImgtList' v-if="schemeFrom.Type!=2" :title="'普通影像细则'" />
				</el-col>
				<el-col :span="colSpan">
					<new-scheme-details-table-img-report :list='newSchemeReportList' v-if="schemeFrom.Type!=1" :title="'普通报告细则'" />
				</el-col>
				<el-col :span="colSpan">
					<new-scheme-details-table-img-report :list='newSchemeHistoryList' v-if="schemeFrom.Type!=1 && schemeFrom.Type!=2 && schemeFrom.Type!=3" :title="'普通病史细则'" />
				</el-col>
			</el-row>
			<el-row>
				<el-form-item>
					<el-button class="mart40" type="primary" @click="onSubmit">保存</el-button>
				</el-form-item>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import newSchemeDetailsTableImg from '../../components/plan/newSchemeDetailsTableImg'
	import newSchemeDetailsTableReport from '../../components/plan/newSchemeDetailsTableReport.vue'
	import newSchemeDetailsTableImgReport from '../../components/plan/newSchemeDetailsTableImgReport.vue'
	import newSchemeDetailsTableHistory from '../../components/plan/newSchemeDetailsTableHistory.vue'
	import newSchemeDetailsTableSerious from '../../components/plan/newSchemeDetailsTableSerious.vue'
	import { mapState, mapActions, mapMutations } from 'vuex'
	export default {
		data() {
			return {
				dialogserious:false,
				rules: {
					Name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}, ],
					Type: [{
						required: true,
						message: '请选择类型',
						trigger: 'change'
					}, ],
					ModalityType: [{
						type: 'array',
						required: true,
						message: '请至少选择一个设备类型',
						trigger: 'change'
					}, ],
					Mode: [{
						required: true,
						message: '请选择模式',
						trigger: 'change'
					}, ],
				},
			}
		},
		components: {
			newSchemeDetailsTableImg,
			newSchemeDetailsTableReport,
			newSchemeDetailsTableImgReport,
			newSchemeDetailsTableSerious,
			newSchemeDetailsTableHistory
		},
		computed: {
			...Vuex.mapState('managerPlan', ['newSpecialSIList','newreportSpecialSIList','isSpecialType','detailsRulesParameter', 'schemeFrom', 'newSchemeDetailsListReport','newSchemeDetailsHistoryReport', 'newSchemeDetailsImgReport', 'setdialogVisible', 'newSchemeImgtList', 'newSchemeReportList', 'loading','scoreitemParameter','newSchemeHistoryList']),
			colSpan() {
				console.log(this.schemeFrom.Type,'vvvvvv')
				if(this.schemeFrom.Type==4) {
					return 8
				}else if(this.schemeFrom.Type==3) {
					return 12
				}else{
					return 24
				}
			}
		},
		created() {
			this.GetReportModality()
		},
		methods: {
			...Vuex.mapMutations('managerPlan', ['setSchemeScoreitemParameter', 'setDatePickerDetails', 'clearSetSchemeScoreitemParameter', 'setLoading']),
			...Vuex.mapActions('managerPlan', ['createorupdateQcplan', 'scoreitemNew','GetReportModality']),
			//关闭弹窗
			cancelClick(){
				this.setdialogVisible.dialogVisible = false;
			},
			seachTab(type){
				this.schemeFrom.Enable = type;
			},
			add() {
				let obj = {
					OptionGuid: "",
					Description: "",
					Score: "",
					Remark: "",
				}
				this.rulesFrom.OptionList.push(obj)
			},
			remove(index) {
				this.rulesFrom.OptionList.splice(index, 1)
			},
			onSubmit(formName) {
				this.$refs.schemeFrom.validate((valid) => {
					// this.setLoading(true);
					if(valid) {
						this.createorupdateQcplan()
					} else {
						return false;
					}
				});

			},
			look(type) {
				const _this = this;
				_this.isSpecialType.type = type;
				_this.$refs.schemeFrom.validate((valid) => {
					if(valid) {
						_this.setSchemeScoreitemParameter()
						if (type) {
							_this.scoreitemParameter.ScoreItemType = 0;
							_this.scoreitemParameter.specialType = 1;
							_this.dialogserious= true;
						}else{
							_this.scoreitemParameter.specialType = 2;
							_this.setdialogVisible.dialogVisible = true;
						}
						_this.setDatePickerDetails()
						_this.scoreitemNew().then(()=>{
							_this.$refs.reportTable.echo();
							_this.$refs.reportImgTable.echo();
							_this.$refs.reportHistoryTable.echo();
;						})
						// this.createorupdateQcplan()
					} else {
						return false;
					}
				});
			},
			closeElDialog() {
				this.clearSetSchemeScoreitemParameter();

			},
			getColSpan(type, col) {
				if (type == 4) return 8;
				if (type == 3) return col === 'img' || col === 'report' ? 12 : 0;
				if (type == 2) return col === 'report' ? 24 : 0;
				if (type == 1) return col === 'img' ? 24 : 0;
				return 0;
			}
		}

	}
</script>